import { combineReducers } from "redux";
import accommodation from "../slices/accommodation.js";
import alerts from "../slices/alerts.js";
import colorSchemes from "../slices/colorSchemes.js";
import fonts from "../slices/fonts.js";
import languages from "../slices/languages.js";
import legalNav from "../slices/legalNav.js";
import linkSelect from "../slices/linkSelect.js";
import loadStates from "../slices/loadStates.js";
import login from "../slices/login.js";
import mediaLibrary from "../slices/mediaLibrary.js";
import modules from "../slices/modules/index.js";
import user from "../slices/user.js";
import issues from "./issues.js";
import logos from "./logos.js";
import pages from "./pages.js";
import partners from "./partners.js";
import prices from "./prices.js";
import publish from "./publish.js";
import revisions from "./revisions.js";
import richEditor from "./richEditor.js";
import rooms from "./rooms.js";
import seo from "./seo/index.js";
import sites from "./sites.js";
import specials from "./specials.js";

export const adminReducer = combineReducers({
  accommodation,
  alerts,
  colorSchemes,
  fonts,
  languages,
  legalNav,
  linkSelect,
  login,
  partners,
  logos,
  mediaLibrary,
  modules,
  pages,
  publish,
  richEditor,
  rooms,
  prices,
  sites,
  specials,
  user,
  loadStates,
  revisions,
  seo,
  issues,
});

export const generatorReducer = combineReducers({
  accommodation,
  colorSchemes,
  fonts,
  legalNav,
  partners,
  logos,
  mediaLibrary,
  modules,
  pages,
  richEditor,
  sites,
  loadStates,
});
